import React from "react";

import { Box, Theme } from "@mui/material";

export type PillTone =
  | "safe"
  | "success"
  | "informative"
  | "takeNote"
  | "neutral"
  | "accent";

function pillToneSx(theme: Theme, tone: PillTone) {
  const { palette } = theme;
  switch (tone) {
    case "safe":
      return {
        backgroundColor: palette.oscar.light.surface.safe,
        color: palette.grey[900],
      };
    case "success":
      return {
        backgroundColor: palette.oscar.light.surface.safe,
        color: palette.oscar.light.content.success,
      };
    case "accent":
      return {
        backgroundColor: palette.secondary.main,
        color: palette.common.white,
      };
    case "informative":
      return {
        backgroundColor: palette.oscar.light.surface.informative,
        color: palette.oscar.light.content.informative,
      };
    case "takeNote":
      return {
        backgroundColor: palette.oscar.light.surface.takeNote,
        color: palette.secondary.main,
      };
    case "neutral":
    default:
      return {
        backgroundColor: palette.grey[300],
        color: palette.grey[700],
      };
  }
}

export const Pill = ({
  tone,
  children,
}: {
  tone: PillTone;
  children: React.ReactNode;
}) => (
  <Box
    component="span"
    sx={(theme) => ({
      ...theme.typography.labelSMedium,
      display: "inline-flex",
      alignItems: "center",
      padding: "2px 9px",
      borderRadius: "999px",
      flexShrink: 0,
      ...pillToneSx(theme, tone),
    })}
  >
    {children}
  </Box>
);
